module.exports = __webpack_public_path__ + "assets/img/Travel_004.ed707e6f-ps.jpg";